import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { EGIS_SERVICE_CALLER, MAX_INT32_VAL } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { RabatKampagneService } from 'src/app/api/services';
import { RabatKampagneDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/rabat-kampagne-dto';

@Component({
    selector: 'app-rabat-kampagne-form',
    templateUrl: './rabat-kampagne-form.component.html',
    styleUrls: ['./rabat-kampagne-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RabatKampagneFormComponent implements OnInit {
  @Input() rabatForm: UntypedFormGroup;
  @Input() isPrivatKunde: boolean;
  @Input() maxKontantRabat: number = MAX_INT32_VAL;

  rabatkampagner: RabatKampagneDto[] = [];

  get rabatkampagne() {
    return this.rabatForm.get('rabatkampagne');
  }

  constructor(
    private fb: UntypedFormBuilder,
    private errorHandler: ErrorHandlerService,
    private rabatkampagnerService: RabatKampagneService) {
  }

  async ngOnInit(): Promise<void> {
    await this.fetchRabatkampagnerAsync();
  }

  onRabatkampagneChanged(selectedKampagne: RabatKampagneDto) {
    this.rabatForm.get('rabatTekst').setValue(selectedKampagne.tekst);
    this.rabatForm.get('rabatKontant').setValue(this.isPrivatKunde ? selectedKampagne.kontant * 1.25 : selectedKampagne.kontant);
    this.rabatForm.get('rabatProcent').setValue(selectedKampagne.procent);
    this.rabatForm.get('engangsRabat').setValue(selectedKampagne.isEngangs);
    this.rabatForm.get('rabatSplit').setValue(selectedKampagne.partnerShare == null ? -1 : selectedKampagne.partnerShare);
  }

  get rabatkampagnerSortedByName() {
    return this.rabatkampagner.sort((a, b) => (a.name < b.name ? -1 : 1));
  }

  async fetchRabatkampagnerAsync() {
    await this.rabatkampagnerService
      .getActiveRabatKampagner({
        caller: EGIS_SERVICE_CALLER
      })
      .toPromise()
      .then((response) => {
        this.rabatkampagner = response;
      })
      .catch((error) => {
        this.errorHandler.HandleError(error);
      });
  }
}
